import { jsxs as u, jsx as c } from "react/jsx-runtime";
import { useState as C, useRef as L, useEffect as b } from "react";
import { O as k } from "./ODSText.D6mgyggF.js";
import { O as x } from "./ODSSwitchIcon.Bu7z9GAD.js";
import { O as N } from "./ODSRow.Du_e7gfN.js";
import { O as g } from "./ODSColumn.B8Qu83P2.js";
import { c as s } from "./index.CWkFp9WS.js";
import '../assets/ODSSwitch.css';const P = ({
  size: e = "large",
  name: h,
  selected: a,
  disabled: t = !1,
  label: i,
  defaultSelected: m = !1,
  containerProps: O,
  className: f,
  inputProps: w,
  onSelectedChange: r,
  ...p
}) => {
  const [o, S] = C(
    m ?? !1
  ), D = L(null);
  b(() => {
    a !== void 0 && S(a);
  }, [a]);
  const n = (d) => {
    const l = d.target.checked;
    a === void 0 && S(l), r && r(l);
  };
  return /* @__PURE__ */ u(
    N,
    {
      as: "label",
      className: s("ODSSwitch", `ODSSwitch--size-${e}`, f),
      ...O,
      onClick: n,
      children: [
        /* @__PURE__ */ c(
          x,
          {
            size: e,
            readOnly: p.readOnly,
            "aria-disabled": t,
            checked: o,
            inputProps: {
              name: h,
              disabled: t,
              ref: D,
              role: "switch",
              "aria-label": i,
              checked: o,
              onChange: n,
              ...w
            },
            disabled: t
          }
        ),
        /* @__PURE__ */ c(
          g,
          {
            className: s(
              "ODSSwitch-LabelContainer",
              `ODSSwitch-LabelContainer--size-${e}`
            ),
            children: i && /* @__PURE__ */ c(
              k,
              {
                as: "span",
                className: s(
                  "ODSSwitch-SwitchLabel",
                  `ODSSwitch-SwitchLabel--size-${e}`,
                  t ? "ODSSwitch-SwitchLabel--disabled" : ""
                ),
                children: i
              }
            )
          }
        )
      ]
    }
  );
};
export {
  P as O
};
//# sourceMappingURL=ODSSwitch.SipGSwQR.js.map
